import { combineReducers } from 'redux'
import main from './main'
import mainV2 from './main-v2'
import tester from './tester'
import firstSteps from './firstSteps'

export default combineReducers({
  main,
  mainV2,
  tester,
  firstSteps,
})
